module.exports = __webpack_public_path__ + "static/media/ic_configure_hover.cc54ff5b.svg";